import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { Button, Card, Pagination, Row, Spin, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../../../assets/styles/InterbankPlacement.css";
import DownloadTableButtons from "../../../../components/layouts/enhancement/DownloadTableButtons";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import { rightAction } from "../../../../redux/actions";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import TableSearchFilter from "../../component/TableSearchFilter";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../contractbooking.config";
import { useGetContractTreasuryBillList } from "../../hooks/useServerActions";

const data = [
  {
    key: "1",
    productName: "Solo Leveling Placement",
    counterpartyType: [
      "Commercial Bank",
      "Merchant Bank",
      "Payment Service Bank",
    ],
    currency: "Nigeria Naira (₦)",
    status: "Active",
    productCode: "IBP001",
  },
  {
    key: "2",
    productName: "BANK FEES ACB",
    counterpartyType: ["Commercial Bank"],
    currency: "Nigeria Naira (₦)",
    status: "Closed",
    productCode: "IBP001",
  },
];

// Status color mapping
const statusColors = {
  Active: "green",
  Closed: "red",
  Matured: "processing",
  Rejected: "error",
  Approved: "processing",
  PrematureClosed: "default",
  WithdrawnByApplicant: "processing",
  "Submitted&PendingApproval": "purple",
};

const statusStyle = {
  Active: {
    borderColor: "#ABEFC6",
    color: "#067647",
    backgroundColor: "#ECFDF3",
  },
  Closed: {
    borderColor: "#EAECF0",
    color: "#344054",
    backgroundColor: "#F9FAFB",
  },
  Matured: {
    borderColor: "#B2DDFF",
    color: "#175CD3",
    backgroundColor: "#EFF8FF",
  },
  Rejected: {
    borderColor: "#FECDCA",
    color: "#B42318",
    backgroundColor: "#FEF3F2",
  },
  Approved: {
    borderColor: "#EEF4FF",
    color: "#3538CD",
    backgroundColor: "#FEF3F2",
  },
  PrematureClosed: {
    borderColor: "#D5D9EB",
    color: "#363F72",
    backgroundColor: "#F8F9FC",
  },
  WithdrawnByApplicant: {
    borderColor: "#B9E6FE",
    color: "#026AA2",
    backgroundColor: "#F0F9FF",
  },
  "Submitted&PendingApproval": {
    borderColor: "#D9D6FE",
    color: "#5925DC",
    backgroundColor: "#F4F3FF",
  },
};

const ContractBookingManageTreasuryBill = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const pageSize = 10; //number of items per page
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableStatus, setTableStatus] = useState("Status");
  const [searchText, setSearchText] = useState("");
  const { data, loading } = useGetContractTreasuryBillList(session);

  console.log(data);
  const filteredData =
    tableStatus === "Status"
      ? data
      : data.filter((item) => item.status === tableStatus);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  useEffect(() => {
    // BOM.HasPermission("READ_TREASURYBILLCONTRACT") && getTreasuryBillList();y
    BOM.HasPermission("CREATE_TREASURYBILLCONTRACT") &&
      rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const totalPages = Math.ceil(filteredData.length / pageSize);

  const onSelectItemAction = (objParam, selectedRow) => {
    // If no row or multiple rows selected, reset read and update
    if (objParam.length !== 1) {
      setSelectedRow(null);
      dispatch({ type: cnt.CLEAR_RIGHT_BTN });

      // Re-activate other buttons that should remain (like addBtn)
      BOM.HasPermission("CREATE_TREASURYBILLCONTRACT") &&
        dispatch({ type: cnt.RIGHT_ADD_BTN });
      return;
    }

    setSelectedRow(selectedRow[0]);

    if (BOM.HasPermission("READ_TREASURYBILLCONTRACT")) {
      dispatch({ type: cnt.RIGHT_DETAIL_BTN });
    }
    if (
      selectedRow[0]?.status?.toLowerCase() === "pending" &&
      BOM.HasPermission("UPDATE_TREASURYBILLCONTRACT")
    ) {
      dispatch({ type: cnt.RIGHT_EDIT_BTN });
    }
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(
        body,
        apiConfig.GetTreasuryBillContracts,
        (err, res) => {
          console.log(res);
          if (err) {
            reject(err);
          } else {
            const objList = res;
            let tempArray = [];

            objList.forEach((element) => {
              tempArray.push({
                key: element?.id,
                contractRefId: element?.contractReferenceId || "-",
                customerId: element?.client?.id || "-",
                date:
                  BOM.DateTime(element?.submittedOnDate, "only-date") || "-",
                maturityDate:
                  BOM.DateTime(element?.valueDate, "only-date") || "-",
                dealValue: Number(element?.faceValue)?.toLocaleString() || "-",
                currency: element?.currency.code || "-",
                status: element?.status?.text || "-",
              });
            });
            resolve(tempArray);
          }
        }
      );
    }, "treasury");
  };

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/create-contract-booking-treasury-bill", {
        state: selectedRow,
      });
    } else {
      console.log("No valid row selected or invalid add button.");
    }
  }

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-contract-booking-treasury-bill", {
        state: selectedRow,
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-contract-booking-treasury-bill", {
        state: selectedRow,
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const columns = [
    {
      title: (
        <div className="flex items-center">
          <span>Contract Ref ID</span>
          <CaretDownOutlined style={{ fontSize: "12px", marginLeft: "4px" }} />
        </div>
      ),
      dataIndex: "contractRefId",
      key: "contractRefId",
      // width: "25%",
    },
    {
      title: "Customer ID",
      dataIndex: "customerId",
      key: "customerId",
      width: "20%",
      // render: (types) => (
      //   <div className="flex flex-wrap gap-1">
      //     {types.map((type) => (
      //       <Tag
      //         key={type}
      //         style={{
      //           backgroundColor: "#FDF4FF",
      //           color: "#9F1AB1",
      //           border: "1px solid #F6D0FE",
      //           borderRadius: "16px",
      //           padding: "2px 12px",
      //           marginBottom: "4px",
      //         }}
      //       >
      //         {type}
      //       </Tag>
      //     ))}
      //   </div>
      // ),
    },
    {
      title: (
        <div className="flex items-center">
          <span>Deal Date</span>
          <CaretDownOutlined style={{ fontSize: "12px", marginLeft: "4px" }} />
        </div>
      ),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => {
        console.log(new Date(a.date) - new Date(b.date));
        return new Date(a.date) - new Date(b.date);
      },
      // width: "20%",
    },
    {
      title: (
        <div className="flex items-center">
          <span>Maturity Date</span>
          <CaretDownOutlined style={{ fontSize: "12px", marginLeft: "4px" }} />
        </div>
      ),
      dataIndex: "maturityDate",
      key: "maturityDate",
      // sorter: (a, b) => new Date(a.maturityDate) - new Date(b.maturityDate),
      sorter: (a, b) => {
        console.log(a, b);
        return new Date(a.maturityDate) - new Date(b.maturityDate);
      },
      // width: "20%",
    },
    {
      title: "Deal Value",
      dataIndex: "dealValue",
      key: "dealValue",
      // width: "20%",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      // width: "20%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      // width: "25%",
      render: (text) => {
        let bgColor = "#F9FAFB"; // default bg
        let textColor = "#344054"; // default text
        let border = "1px solid #EAECF0";

        switch (text) {
          case "Active":
            bgColor = "#ECFDF3";
            textColor = "#067647";
            border = "1px solid #ABEFC6";
            break;
          case "Inactive":
            bgColor = "#FEE4E2";
            textColor = "#B42318";
            break;
          case "Matured":
            bgColor = "#EFF8FF";
            textColor = "#175CD3";
            border = "1px solid #B2DDFF";
            break;
          case "Rejected":
            bgColor = "#FEF3F2";
            textColor = "#B42318";
            border = "1px solid #FECDCA";
            break;
          case "Approved":
            bgColor = "#EEF4FF";
            textColor = "#3538CD";
            border = "1px solid #C7D7FE";
            break;
          case "WithdrawnByApplicant":
            bgColor = "#F0F9FF";
            textColor = "#026AA2";
            border = "1px solid #B9E6FE";
            break;
          case "SubmittedAndPendingApproval":
            bgColor = "#F4F3FF";
            textColor = "#5925DC";
            border = "1px solid #D9D6FE";
            break;
          default:
            break;
        }

        return (
          <Tag
            style={{
              padding: "2px 12px",
              borderRadius: "16px",
              border: border,
              fontSize: "12px",
              fontWeight: 500,
              display: "inline-block",
              backgroundColor: bgColor,
              color: textColor,
              textTransform: "capitalize",
            }}
          >
            {text}
          </Tag>
        );
      },
    },
  ];

  const csvColumns = [
    {
      title: "Contract Ref ID",
      dataIndex: "contractRefId",
      key: "contractRefId",
    },
    {
      title: "Customer ID",
      dataIndex: "customerId",
      key: "customerId",
      width: "20%",
    },
    {
      title: "Deal Date",
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => {
        console.log(new Date(a.date) - new Date(b.date));
        return new Date(a.date) - new Date(b.date);
      },
    },
    {
      title: "Maturity Date",
      dataIndex: "maturityDate",
      key: "maturityDate",
      sorter: (a, b) => {
        console.log(a, b);
        return new Date(a.maturityDate) - new Date(b.maturityDate);
      },
    },
    {
      title: "Deal Value",
      dataIndex: "dealValue",
      key: "dealValue",
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  // PAINATION ARROE DISABLING
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return;
    }
    if (type === "next") {
      return;
    }
    return originalElement;
  };

  const searchFIlter = paginatedData.filter((item) =>
    item?.contractRefId?.toLowerCase().includes(searchText.toLowerCase())
  );

  console.log(searchFIlter);
  const selectableOptions = [
    { label: "All Status", value: "Status" },
    {
      label: "Pending",
      value: "Pending",
    },
    { label: "Active", value: "Active" },
    { label: "Closed", value: "Closed" },
    { label: "Matured", value: "Matured" },
    { label: "Rejected", value: "Rejected" },
    { label: "Approved", value: "Approved" },
    { label: "Premature Closed", value: "PrematureClosed" },
    {
      label: "Withdrawn By Applicant",
      value: "WithdrawnByApplicant",
    },
  ];

  const handleSelectOnChange = (value) => {
    setTableStatus(value);
    setCurrentPage(1); // Reset to page 1 on filter change
  };

  React.useEffect(() => {
    setTableStatus(selectableOptions[2].value);
  }, []);

  const hanleOnChangeSearchInput = (e) => {
    const text = e.target.value;
    setSearchText(text);
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onAdd={handleOnCreate}
      onView={handleOnView}
      onEdit={handleOnEdit}
      pageItems={staticConfig.contractbookingTreasuryBillBreadcrumbItems}
    >
      <TopContent
        pageTitle={labelConfig.manageContractBookingtTreasuryBill}
        createPageTitle={labelConfig.contractBookingtTreasuryBill}
      />
      <Spin spinning={loading} size="large">
        <Card
          style={{
            // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <div className="p-6 bg-white rounded-lg shadow-sm check-ant-design">
            {/* Top Bar */}
            <Row style={{ marginBottom: 20 }}>
              <TableSearchFilter
                searchPlaceholder="Search by Ref.ID/Customer ID..."
                selectOptions={selectableOptions}
                selectValue={tableStatus}
                onSelectChange={handleSelectOnChange}
                onSearchChange={hanleOnChangeSearchInput}
                searchText={searchText}
              />

              <DownloadTableButtons
                downloadData={data}
                columns={csvColumns}
                fileName="Treasury Bill Contract List"
                onExportClick={getCsvListData}
              />
            </Row>

            {/* Table */}
            <div className="interbankplacement-table">
              <Table
                className="bond-table"
                rowSelection={{
                  onChange: onSelectItemAction,
                  hideSelectAll: true,
                }}
                columns={columns}
                rowKey="key"
                pagination={false}
                dataSource={searchFIlter}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: 20,
              }}
            >
              <div
                className="interbankplacement-table-pagination"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  disabled={currentPage === 1}
                >
                  <ArrowLeftOutlined />
                  Previous
                </Button>

                <Pagination
                  current={currentPage}
                  total={filteredData.length}
                  pageSize={pageSize}
                  onChange={(page) => setCurrentPage(page)}
                  showSizeChanger={false}
                  itemRender={itemRender}
                  // hideOnSinglePage={true}  // This hides the pagination when there's only one page
                />

                <Button
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage >= totalPages}
                >
                  Next
                  <ArrowRightOutlined />
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractBookingManageTreasuryBill);
